import { useMutation } from '@tanstack/react-query';

import { client } from '../client';

type COIExtraData = {
  company: string;
  represent: string;
  extra?: string;
  text: string;
};

type getCoiLinkParams = {
  customerUuid?: string;
  policyUuid: string;
  coverage: string;
  extra?: COIExtraData;
};

const getCoiLink = async ({ customerUuid, policyUuid, coverage, extra }: getCoiLinkParams) => {
  const res = await client.post<{ pdfUrl: string }>(`v1/generate-coi-new/${policyUuid}/${coverage}`, {
    customerUuid,
    extra,
  });

  return res.data.pdfUrl;
};

export const useGetCoiLink = () => {
  return useMutation({
    mutationFn: (payload: getCoiLinkParams) => getCoiLink(payload),
    onSuccess: (res) => {
      return res;
    },
  });
};
